interface IOptions {
  // 滚动容器
  element?: Element
  // 是否是绝对位移
  absolute?: boolean
}
export default function scrollSmoothly(dis: number, options: IOptions = {}) {
  const scrollElement =
    options.element || document.scrollingElement || document.documentElement
  const initTop = scrollElement.scrollTop
  const delta = options.absolute ? dis - initTop : dis
  let moved = 0

  return function scroll() {
    if (Math.abs(moved) < Math.abs(delta)) {
      /**
       * 200ms内移动delta的距离
       * 200 / 16 得出一共要多少帧
       * delta / (200 / 16)得出每一帧移动的距离
       */
      moved = moved + delta / (200 / 16)
      if (delta > 0) {
        moved = Math.min(moved, delta)
      } else {
        moved = Math.max(moved, delta)
      }
      scrollElement.scrollTop = initTop + moved

      requestAnimationFrame(scroll)
    }
  }
}
